module.exports = __webpack_public_path__ + "static/media/iconStatisticsF.e44b2080.svg";